import React from 'react'
import Rating from '@mui/lab/Rating'
import PropTypes from 'prop-types'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'
import { Icon } from 'bs-unified-ui'

const style = () => ({
  container: {
    display: 'inline-flex',
  },
})

const StyledRating = withStyles({
  decimal: {
    margin: '0 2px',
  },
  icon: {
    '&>div': {
      maskSize: 'auto !important',
      WebkitMaskSize: 'auto !important',
      maskPosition: 'center left !important',
      WebkitMaskPosition: 'center left !important',
    },
  },
})(Rating)

const Star = ({ classes, name, value, type, disabled, ...props }) => (
  <div className={classes.container}>
    <StyledRating
      className={classes.star}
      name={name}
      value={value}
      disabled={disabled}
      precision={0.5}
      emptyIcon={<Icon name="star" color="#33363D66" size={16} />}
      icon={<Icon name="star" type="fill" color="#F3BA50" size={16} />}
      {...props}
    />
  </div>
)

Star.defaultProps = {
  value: 0,
  type: '',
  disabled: false,
  name: '',
}

Star.propTypes = {
  classes: PropTypes.shape().isRequired,
  value: PropTypes.number,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
}

export default withStyles(style)(Star)
